import script from "./ProfileLoyalty.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileLoyalty.vue?vue&type=script&setup=true&lang=js"

import "./ProfileLoyalty.vue?vue&type=style&index=0&id=764d5fc2&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-764d5fc2"]])

export default __exports__